import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserSessionService } from '../services/user-session.service';
import { CommonChecks } from '../utilities/common-checks.utilities';

export const organizationRequiredGuard: CanActivateFn = (_route, _state) => {
  const userSessionService = inject(UserSessionService);
  const router = inject(Router);

  if (CommonChecks.isNullOrUndefined(userSessionService.activeOrganization())) {
    router.navigateByUrl(`users/profile/${userSessionService.activeUser()?.userId}`);
    return false;
  } else {
    return true;
  }

};
